import styled from "styled-components";
import useSuccess from "../../hooks/pay/useSuccess";
import Modal from "../../components/common/Modal";
import Loading from "../../components/common/Loading";
import { useLocation } from "react-router-dom";

function Success(){
    const {id, paymentKey} = useLocation().state;
    const {isOpenModal, modal} = useSuccess(id, paymentKey);
    return(
        <Container>
            {isOpenModal ? <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} onClose={modal.onConfirmClickHandler}/> : <Loading isOpen={!isOpenModal} title={"주문을 처리하고 있습니다"} />}
        </Container>
    )
}

const Container = styled.div`
`

export default Success;